var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "figcaption",
    {
      staticClass: "caption",
      style: { color: _vm.project.colors["text-primary"] },
    },
    [
      _c(_setup.LineCover, { staticClass: "decoration" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col summary" },
        [
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.project.description)),
          ]),
          _vm._v(" "),
          _vm.project.tags !== null
            ? _c(_setup.CaptionTags, {
                attrs: {
                  tags: _vm.project.tags,
                  color: _vm.project.colors["text-secondary"],
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.ProjectCoverMention, { attrs: { project: _vm.project } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }